import type { BoneSources } from '@/views/3d-planner/store/plannerState';
import type { PlannerNodes } from '@/views/3d-planner/scene/plannerSceneState';

/**
 * Project resolved bone geometry-sources (domain data on the Model) onto the scene's mesh nodes.
 * The scene ViewModel calls this when `boneSources` lands, keeping the domain load free of any
 * scene dependency (see docs/threejs-practices.md → "Where scene state lives").
 */
export function bindBoneSources(nodes: PlannerNodes, sources: BoneSources): void {
    nodes.operativeFemur.geometrySource = sources['operative-femur'] ?? null;
    nodes.operativeFemurInternal.geometrySource = sources['operative-femur-internal'] ?? null;
    nodes.operativeHemipelvis.geometrySource = sources['operative-hemipelvis'] ?? null;
    nodes.sacrum.geometrySource = sources['sacrum'] ?? null;
    nodes.contralateralHemipelvis.geometrySource = sources['contralateral-hemipelvis'] ?? null;
    nodes.contralateralFemur.geometrySource = sources['contralateral-femur'] ?? null;
    nodes.metal.geometrySource = sources['metal'] ?? null;
}